<template>
  <div class="summary-property">
    <v-layout row wrap>
      <v-flex xs12>
        <SummaryTitle
          :isCollapsible="isCollapsible"
          :isCollapsed="isCollapsed"
          icon="location_on"
          @clickedToggle="toggleIsCollapsed">
          Details
          <template v-if="displayAction" v-slot:action>
            <EditButton @click="clickEditLocation" />
          </template>
        </SummaryTitle>
      </v-flex>

      <template v-if="!contentIsCollapsed">
        <v-flex
          v-if="location.additionalInstructions"
          class="summary-property--instructions"
          xs12
          py-2>
          "{{location.additionalInstructions}}"
        </v-flex>

        <v-flex xs12>
          <SummaryRow
            label="Occupied:"
            :value="isOccupiedOutput(location.isOccupied)" />
          <SummaryRow
            v-for="field in visibleFields"
            :label="field.name"
            :value="location[field.id] || ''"
            :type="field.type"
            :key="field.id"/>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import EditButton from '@/components/common/EditButton.vue';
import SummaryRow from '@/components/common/SummaryRow.vue';
import SummaryTitle from '@/components/common/SummaryTitle.vue';
import CollapsibleSection from '@/mixins/CollapsibleSection';
import PropertyDetailsMixin from '@/mixins/PropertyDetailsMixin';
import StepUtilities from '@/router/utilities/step-utilities';

export default {
  components: {
    EditButton,
    SummaryRow,
    SummaryTitle,
  },
  mixins: [CollapsibleSection, PropertyDetailsMixin],
  computed: {
    ...mapState('Appointment', {
      location: state => state.locationComponentData ?? {},
    }),
    ...mapGetters('Appointment', ['getCustomFields']),
    visibleFields() {
      return this.getCustomFields.filter(field => field.displayStatus === 'visible' && !field.internal);
    },
  },
  methods: {
    clickEditLocation() {
      StepUtilities.goToPropertyStep(this.$router);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/typography';

.summary-property {
  &--instructions {
    font-size: 1.14rem;
    font-style: italic;
    font-weight: $typography-weight-semibold;
    letter-spacing: 0.03rem;
    line-height: 1.25;
    padding-bottom: 1.25rem !important;
    padding-top: 1.65rem !important;
  }
}
</style>
